<template>
  <v-container class="fill-height">
    <v-row class="align-center justify-center">
      <v-col class="flex-shrink-1 flex-grow-0">
        <v-img src="images/logo.png" class="mx-auto" width="200px" />

        <v-card color="white" class="mt-4" style="width: 550px; max-width: 550px; min-width: 550px;">
          <v-card-text style="position: relative;">
            <!--<div style="position: absolute; top: -2px; right: 5px; max-width: 100px;">
              <v-select
                :items="yearlyMonthlyOptions"
                v-model="yearlyMonthly"
                hide-details
                dense
              />
            </div>-->
            <v-row>
              <v-col cols="6">
                <v-row class="flex-column">
                  <!--<v-col class="mt-n5 pt-0">
                    <div style="max-width: 100px;" class="mx-auto">
                      <v-select
                        :items="yearlyMonthlyOptions"
                        v-model="yearlyMonthly"
                        hide-details
                        dense
                        color="grey--text"
                      />
                    </div>
                  </v-col>-->
                  <v-col>
                    <v-text-field
                      label="Present Value"
                      v-model="presentValue"
                      outlined
                      hide-details
                      @change="format('presentValue')"
                      @focus="format('presentValue','num')"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      :label="(yearlyMonthly == 'Annually' ? 'Annual' : 'Monthly') + ' Payment'"
                      v-model="payment"
                      outlined
                      hide-details
                      @change="format('payment')"
                      @focus="format('payment','num')"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Future Value"
                      v-model="futureValue"
                      outlined
                      hide-details
                      @change="format('futureValue')"
                      @focus="format('futureValue','num')"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      :label="(yearlyMonthly == 'Annually' ? 'Years' : 'Months')"
                      v-model="period"
                      outlined
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters class="fill-height align-center">
                  <v-col class="text-center">
                    <div class="title">Annual Interest Rate</div>
                    <div class="display-3 mt-2" v-html="interestRate"></div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div class="text-center mt-4">
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" @click="reset" class="mr-2" style="min-width: 0px;"><v-icon>mdi-close</v-icon></v-btn>
            </template>
            <span>Reset</span>
          </v-tooltip>
          <v-btn color="green" dark @click="calculate">Calculate</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'TruthCalculator',
    data() {
      return {
        yearlyMonthly: 'Annually',
        yearlyMonthlyOptions: ['Annually','Monthly'],

        interestRate: '&nbsp;',

        presentValue: '',
        payment: '',
        period: '',

        futureValue: ''
      }
    },
    watch: {
      yearlyMonthly: function(newVal) {
        if(newVal == 'Monthly') {
          if(!this.blank(this.payment)) {
            let payment = parseFloat(this.payment.replace(/\D/g,"")) / 12;
            this.payment = this.formatDollar(payment);
          }

          if(!this.blank(this.period)) {
            let period = this.period.toString();
            period = parseFloat(period.replace(/(\D|\.)/g,"")) * 12;
            this.period = Math.round(period * 100) / 100;
          }
        } else {
          if(!this.blank(this.payment)) {
            let payment = parseFloat(this.payment.replace(/\D/g,"")) * 12;
            this.payment = this.formatDollar(payment);
          }

          if(!this.blank(this.period)) {
            let period = this.period.toString();
            period = parseFloat(period.replace(/(\D|\.)/g,"")) / 12;
            this.period = Math.round(period * 100) / 100;
          }
        }
        this.interestRate = '&nbsp;';
      }
      /*presentValue: function(newValue) {
        this.$nextTick(() => this.presentValue = this.formatDollar(newValue));
      },*/
      /*annualPayment: function(newValue) {
        this.$nextTick(() => this.annualPayment = this.formatDollar(newValue));
      },
      futureValue: function(newValue) {
        this.$nextTick(() => this.futureValue = this.formatDollar(newValue));
      }*/
    },
    methods: {
      reset: function() {
        this.interestRate = '&nbsp;';
        this.period = '';
        this.payment = '';
        this.presentValue = '';
        this.futureValue = '';
        this.yearlyMonthly = 'Annually';
      },
      format: function(val,type) {
        if(type == 'num') {
          this[val] = this[val].replace(/\D/g,"");
        } else {
          this[val] = this.formatDollar(this[val]);
        }
      },
      formatDollar: function(val) {
        if(val === '' || val === null) return '';
        const result = Number(val).toLocaleString('en', {minimumFractionDigits: 0,maximumFractionDigits: 0 });
        return result;
      },
      blank: function(val) {
        return (typeof val === 'undefined' || val === '' || val === null);
      },
      calculate: function() {
        if( this.blank(this.presentValue) ||
            this.blank(this.payment) ||
            this.blank(this.futureValue) ||
            this.blank(this.period)
        ) {
          this.interestRate = '&nbsp;';
        }
        let pv = (parseFloat(this.presentValue.replace(/\D/g,"")) * -1);
        let fv = parseFloat(this.futureValue.replace(/\D/g,""));

        let payment = (parseFloat(this.payment.replace(/\D/g,"")) * -1);
        
        let period = parseFloat(this.period);

        let rate = this.rate(period, payment,pv,fv,1);
        if(rate) {
          let finalRate = (Math.round(rate * 10000 * (this.yearlyMonthly == 'Monthly' ? 12 : 1)) / 100);
          this.interestRate = finalRate + '%';
        } else {
          this.interestRate = "&nbsp;";
        }

      },
      /*rate: function(nper, pmt, pv, fv, type, guess) {
        // Sets default values for missing parameters
        fv = typeof fv !== 'undefined' ? fv : 0;
        type = typeof type !== 'undefined' ? type : 0;
        guess = typeof guess !== 'undefined' ? guess : 0.1;

        // Sets the limits for possible guesses to any
        // number between 0% and 100%
        var lowLimit = 0;
        var highLimit = 1;

        // Defines a tolerance of up to +/- 0.00005% of pmt, to accept
        // the solution as valid.
        //var tolerance = Math.abs(0.00000005 * pmt);
        var tolerance = Math.abs(0.0005 * pmt);

        // Tries at most 40 times to find a solution within the tolerance.
        for (var i = 0; i < 10000; i++) {
          // Resets the balance to the original pv.
          var balance = pv;

          // Calculates the balance at the end of the loan, based
          // on loan conditions.
          for (var j = 0; j < nper; j++ ) {
            if (type == 0) {
              // Interests applied before payment
              balance = balance * (1 + guess) + pmt;
            } else {
              // Payments applied before insterests
              balance = (balance + pmt) * (1 + guess);
            }
          }

          // Returns the guess if balance is within tolerance.  If not, adjusts
          // the limits and starts with a new guess.
          if (Math.abs(balance + fv) < tolerance) {
            return guess;
          } else if (balance + fv > 0) {
            // Sets a new highLimit knowing that
            // the current guess was too big.
            highLimit = guess;
          } else  {
            // Sets a new lowLimit knowing that
            // the current guess was too small.
            lowLimit = guess;
          }

          // Calculates the new guess.
          guess = (highLimit + lowLimit) / 2;
        }

        // Returns null if no acceptable result was found after 40 tries.
        return null;
      },*/
      rate: function(periods, payment, present, future, type, guess) {
        guess = (guess === undefined) ? 0.1 : guess;
        future = (future === undefined) ? 0 : future;
        type = (type === undefined) ? 0 : type;
      
        // Set maximum epsilon for end of iteration
        var epsMax = 1e-8;
      
        // Set maximum number of iterations
        var iterMax = 100000;
      
        // Implement Newton's method
        var y, y0, y1, x0, x1 = 0,
          f = 0,
          i = 0;
        var rate = guess;
        if (Math.abs(rate) < epsMax) {
          y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
        } else {
          f = Math.exp(periods * Math.log(1 + rate));
          y = present * f + payment * (1 / rate + type) * (f - 1) + future;
        }
        y0 = present + payment * periods + future;
        y1 = present * f + payment * (1 / rate + type) * (f - 1) + future;
        i = x0 = 0;
        x1 = rate;
        while ((Math.abs(y0 - y1) > epsMax) && (i < iterMax)) {
          rate = (y1 * x0 - y0 * x1) / (y1 - y0);
          x0 = x1;
          x1 = rate;
            if (Math.abs(rate) < epsMax) {
              y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
            } else {
              f = Math.exp(periods * Math.log(1 + rate));
              y = present * f + payment * (1 / rate + type) * (f - 1) + future;
            }
          y0 = y1;
          y1 = y;
          ++i;
        }
        return rate;
      }
    }
  }
</script>
